var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00909 0.131008C7.87555 -0.0063918 6.72915 0.248966 5.76109 0.854498C4.86015 1.41804 4.16436 2.25318 3.77199 3.23636C3.28202 3.29041 2.80483 3.42996 2.36223 3.6491C1.86558 3.895 1.42223 4.23632 1.05749 4.65357C0.320865 5.49623 -0.0508435 6.597 0.0241369 7.71373C0.0991171 8.83046 0.614644 9.87166 1.45731 10.6083C1.81787 10.9235 2.22567 11.1718 2.66176 11.347C2.68733 11.3083 2.71421 11.27 2.74244 11.2324C3.49986 10.2225 4.93254 10.0178 5.94244 10.7753L6.54563 11.2276L9.71979 7.65671C10.5585 6.71321 12.0032 6.62822 12.9467 7.46689C13.8902 8.30557 13.9752 9.7503 13.1365 10.6938L12.2928 11.6429H12.3115H12.3149C13.2183 11.6375 14.0884 11.301 14.7604 10.6972C15.4324 10.0933 15.8596 9.26402 15.9612 8.36632C16.0628 7.46861 15.8317 6.5648 15.3116 5.82605C14.8346 5.14832 14.1447 4.65266 13.3551 4.41544C13.2119 3.36025 12.7346 2.37632 11.9902 1.60955C11.1948 0.790261 10.1426 0.268408 9.00909 0.131008ZM12.0688 9.74471C12.3832 9.39089 12.3515 8.84912 11.9976 8.53462C11.6438 8.22012 11.102 8.25199 10.7875 8.60581L6.74006 13.1592L5.0853 11.9181C4.70659 11.6341 4.16933 11.7109 3.8853 12.0895C3.60126 12.4683 3.67802 13.0055 4.05672 13.2895L6.34244 15.0038C6.69907 15.2713 7.20119 15.2207 7.49736 14.8876L12.0688 9.74471Z",
    fill: "#CBCED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCheckIcon);
export default __webpack_public_path__ + "static/media/cloudCheckIcon.43e8959f66c10d7e0747f8a2df2ea808.svg";
export { ForwardRef as ReactComponent };